import { render, staticRenderFns } from "./PdfContainer.vue?vue&type=template&id=7067ea64&scoped=true"
import script from "./PdfContainer.vue?vue&type=script&lang=js"
export * from "./PdfContainer.vue?vue&type=script&lang=js"
import style0 from "./PdfContainer.vue?vue&type=style&index=0&id=7067ea64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7067ea64",
  null
  
)

export default component.exports